module.exports = __webpack_public_path__ + "media/images/lb/987-64d9980dabfdbd56f46a7dafe7bbb065.svg";